export default __webpack_public_path__ + "static/media/emptySelectedData.5c477974.svg";